import React from 'react';
import { Route } from 'react-router-dom';

const TextbookList = React.lazy(
  () => import('pages/teacherSide/textbook/TextbookList/TextbookList'),
);
const TextbookAddEdit = React.lazy(
  () => import('pages/teacherSide/textbook/TextbookAddEdit/TextbookAddEdit'),
);
const TextbookDetail = React.lazy(
  () => import('pages/teacherSide/textbook/TextbookDetail/TextbookDetail'),
);
const TextbookXlsxAdd = React.lazy(
  () => import('pages/teacherSide/textbook/TextbookXlsxAdd/TextbookXlsxAdd'),
);
const TextbookDistList = React.lazy(
  () => import('pages/teacherSide/textbook/TextbookDistList/TextbookDistList'),
);
const TextbookDistAdd = React.lazy(
  () => import('pages/teacherSide/textbook/TextbookDistAdd/TextbookDistAdd'),
);
const TextbookDistDetail = React.lazy(
  () => import('pages/teacherSide/textbook/TextbookDistDetail/TextbookDistDetail'),
);

const RouteListTSTextbook = (
  <Route path="/teacherSide/textbook/">
    <Route path="list" element={<TextbookList />} />
    <Route path="add" element={<TextbookAddEdit mode="add" />} />
    <Route path="bulkAdd" element={<TextbookXlsxAdd />} />
    <Route path="edit/:textbookId" element={<TextbookAddEdit mode="edit" />} />
    <Route path="detail/:textbookId" element={<TextbookDetail />} />
    <Route path="dist/list" element={<TextbookDistList />} />
    <Route path="dist/add" element={<TextbookDistAdd />} />
    <Route path="dist/detail/:distGroupId" element={<TextbookDistDetail />} />
  </Route>
);

export default RouteListTSTextbook;
